import { useSharedStateSelector } from '@trello/shared-state';

import { routerState, type LocationState } from './routerState';

export function useLocation(): LocationState {
  const location = useSharedStateSelector(
    routerState,
    (value) => value.location,
  );
  return location;
}
